import { QueryClient } from '@tanstack/react-query';

import { FaceToFaceTreatmentKeywordsQuery } from '@/types/bff/gql-schema';
import { HospitalTreatmentVo } from '@/types/hospital';
import { useFaceToFaceTreatmentKeywordsQuery } from './hospitalMain.gql.impl';

const parseHospitalTreatmentVo = (data: FaceToFaceTreatmentKeywordsQuery): Array<HospitalTreatmentVo> => {
  return data.faceToFaceTreatmentKeywords.map((data) => {
    return { ...data };
  });
};

const useFaceToFaceTreatmentKeywords = () => {
  const { data } = useFaceToFaceTreatmentKeywordsQuery(undefined, {
    select: parseHospitalTreatmentVo,
  });
  return { data };
};

export default useFaceToFaceTreatmentKeywords;

useFaceToFaceTreatmentKeywords.prefetchQuery = async (queryClient: QueryClient) => {
  await queryClient.prefetchQuery(
    useFaceToFaceTreatmentKeywordsQuery.getKey(),
    useFaceToFaceTreatmentKeywordsQuery.fetcher()
  );
};
